import React from "react";
import Icons from "components/icons";
import { AppContentStatus } from "components/app-content";
import { parseHttpUrl } from "utils/http-url";
import Localize from "components/service/localize";
import { getDocumentMenuLabelKey } from "./document-const";

const DocumentMenuItems = ({ resource }) => (
    <>
        {(resource.loading || resource.error) && <li className="additional-menu-document-status">
            <AppContentStatus resource={resource} />
        </li>}
        {resource.items.map(document => {
            if (document.active !== true || document.placement !== "additional_menu" || typeof document.title !== "string" || !document.title.trim()) return null;
            const url = parseHttpUrl(document.getFileUrl);
            if (!url) return null;
            const labelKey = getDocumentMenuLabelKey(document.title);

            return <li key={document.id}>
                <a href={url.href} target="_blank" rel="noopener noreferrer" className="with-icon additional-menu-document">
                    <Icons.Document />
                    <span className={`additional-menu-document-title${labelKey ? " additional-menu-document-title--localized" : ""}`}>
                        {labelKey ? <Localize>{labelKey}</Localize> : document.title}
                    </span>
                </a>
            </li>;
        })}
    </>
);

export default DocumentMenuItems;
